/* eslint-disable max-lines */
(function () {
        'use strict';

        angular
            .module('app')
            .factory('API', API);

        API.$inject = ['config', '$http', '$location', '$resource',];

        function API(config, $http, $location, $resource) {
            var url = config.get('apiEndpoint'),
                service = {
                    AdminLogs: adminLogs(),
                    AdminComments: adminComments(),
                    B2bPartners: b2bPartners(),
                    Badge: badge(),
                    CacHistory: cacHistory(),
                    Campaign: campaign(),
                    CampaignCode: campaignCode(),
                    Contract: contract(),
                    ContractType: contractType(),
                    Game: game(),
                    GameBundle: gameBundle(),
                    getApiUrl: function () {
                        return url;
                    },
                    Lead: lead(),
                    Order: order(),
                    Group: group(),
                    School: school(),
                    OpenSchool: openSchool(),
                    Statistic: statistic(),
                    RecycleBin: recycleBin(),
                    Registration: registration(),
                    Segment: segment(),
                    Subject: subject(),
                    Subscription: subscription(),
                    SubscriptionPlan: subscriptionPlan(),
                    SubscriptionLog: subscriptionLog(),
                    Teacher: teacher(),
                    User: user(),
                    UserExport: userExport(),
                    WinbackCampaign: winbackCampaign(),
                    WinbackOffer: winbackOffer(),
                    WinbackStateOffer: winbackStateOffer(),
                    Request: request,
                };

            return service;

            function request(method, endpoint, data) {
                if (method === 'POST') {
                    return $http({
                        method: 'POST',
                        url: url + '/api/admin/v1/' + endpoint + '/',
                        data: JSON.stringify(data)
                    });
                } else {
                    return $http({
                        method: 'GET',
                        url: url + '/api/admin/v1/' + endpoint + '/',
                        data: data,
                    });
                }
            }

            function adminLogs() {
                return $resource(url + '/api/admin/v1/admin-logs/:id/', {
                    id: '@id',
                }, extendEndpoints({
                    get: {
                        method: 'GET',
                    },
                }, ['search']));
            }

            function adminComments() {
                return $resource(url + '/api/admin/v1/admin-comments/', {}, {
                    get: {
                        method: 'GET',
                    },
                });
            }

            function b2bPartners() {
                return $resource(url + '/api/admin/v1/b2b-partners/:id/:action/:target/', {
                    action: '@action',
                    id: '@id',
                    target: '@target',
                }, extendEndpoints({}, ['comments', 'search']));
            }

            function badge() {
                return $resource(url + '/api/admin/v1/badges/:id/:action/:target/', {
                    action: '@action',
                    id: '@id',
                    target: '@target',
                }, extendEndpoints({}, ['comments', 'search']));
            }

            function cacHistory() {
                return $resource(url + '/api/admin/v1/cac-histories/:id/', {
                    id: '@id',
                }, extendEndpoints({}, ['search']));
            }

            function campaign() {
                return $resource(url + '/api/admin/v1/campaigns/:id/:action/:target/', {
                    action: '@action',
                    id: '@id',
                }, extendEndpoints({}, ['comments', 'recycle', 'search']));
            }

            function campaignCode() {
                return $resource(url + '/api/admin/v1/campaign-codes/:id/:action/', {
                    action: '@action',
                    id: '@id',
                }, extendEndpoints({}, ['search']));
            }

            function contract() {
                return $resource(url + '/api/admin/v1/contracts/:id/:action/:target/', {
                    action: '@action',
                    id: '@id',
                    target: '@target',
                    schoolId: '@schoolId',
                    groupId: '@groupId'
                }, extendEndpoints({
                    connectGroup: {
                        method: 'PATCH',
                        url: url + '/api/admin/v1/contracts/:id/connect-group/:groupId/',
                    },
                    disconnectGroup: {
                        method: 'PATCH',
                        url: url + '/api/admin/v1/contracts/:id/disconnect-group/:groupId/',
                    },
                    connectSchool: {
                        method: 'PATCH',
                        url: url + '/api/admin/v1/contracts/:id/connect-school/:schoolId/',
                    },
                    disconnectSchool: {
                        method: 'PATCH',
                        url: url + '/api/admin/v1/contracts/:id/disconnect-school/:schoolId/',
                    },
                }, ['comments', 'search']));
            }

            function contractType() {
                return $resource(url + '/api/admin/v1/contract-types/:id/:action/:target/', {
                    action: '@action',
                    id: '@id',
                    target: '@target',
                }, extendEndpoints({}, ['comments', 'search']));
            }

            function group() {
                return $resource(url + '/api/admin/v1/groups/:id/:action/:target/', {
                    action: '@action',
                    id: '@id',
                    target: '@target',
                }, extendEndpoints({
                    usage: {
                        method: 'GET',
                        params: {
                            action: 'usage',
                        },
                        isArray: true,
                    },
                }, ['comments', 'recycle', 'search']));
            }

            function game() {
                return $resource(url + '/api/admin/v1/games/:tag/:action/:target/', {
                    action: '@action',
                    tag: '@tag',
                    target: '@target',
                }, extendEndpoints({
                    get: {
                        method: 'GET',
                        cache: true,
                    },
                    update: {
                        method: 'PATCH',
                        params: {
                            id: '@tag',
                        },
                    },
                }, ['comments', 'search', 'translations']));
            }

            function gameBundle() {
                return $resource(url + '/api/admin/v1/game-bundles/:id/:action/:target/', {
                    action: '@action',
                    id: '@id',
                    target: '@target',
                }, extendEndpoints({
                    delete: {
                        method: 'DELETE',
                    },
                }, ['comments', 'search']));
            }

            function lead() {
                return $resource(url + '/api/admin/v1/follow-ups/:id/:action/:target/', {
                    action: '@action',
                    id: '@id',
                }, extendEndpoints({}, ['search']));
            }

            function order() {
                return $resource(url + '/api/admin/v1/orders/:id/:action/', {
                    id: '@id',
                    action: '@action',
                }, extendEndpoints({}, ['search']));
            }

            function segment() {
                return $resource(url + '/api/admin/v1/segments/:id/:action/', {
                    id: '@id',
                    action: '@action',
                }, extendEndpoints({
                    update: {
                        method: 'PATCH',
                        params: {
                            id: '@tag',
                        },
                    },
                }, ['search']));
            }

            function subject() {
                return $resource(url + '/api/admin/v1/subjects/:id/:action/', {
                    id: '@id',
                    action: '@action',
                }, extendEndpoints({}, ['search', 'comments', 'translations']));
            }

            function subscription() {
                return $resource(url + '/api/admin/v1/subscriptions/:id/:action/', {
                    id: '@id',
                    action: '@action',
                }, {
                    refresh: {
                        method: 'PATCH',
                        params: {
                            action: 'refresh',
                        }
                    },
                    cancel: {
                        method: 'PATCH',
                        params: {
                            action: 'cancel',
                        }
                    },
                    fix: {
                        method: 'PATCH',
                        params: {
                            action: 'fix',
                        }
                    },
                    log: {
                        method: 'GET',
                        params: {
                            action: 'log',
                        }
                    },
                    stripeChangePlan: {
                        method: 'PATCH',
                        params: {
                            action: 'stripe-set-plan',
                        }
                    },
                    getCredit: {
                        method: 'GET',
                        params: {
                            action: 'get-credit',
                        }
                    },
                    giveCredit: {
                        method: 'POST',
                        params: {
                            action: 'give-credit',
                        }
                    }
                });
            }

            function subscriptionPlan() {
                return $resource(url + '/api/admin/v1/subscription-plans/:id/:action/', {
                    id: '@id',
                    action: '@action',
                }, extendEndpoints({
                    getCached: {
                        method: 'GET',
                        cache: true,
                        params: {
                            action: 'search',
                            'per-page': -1
                        }
                    }
                }, ['comments', 'search']));
            }

            function subscriptionLog() {
                return $resource(url + '/api/admin/v1/subscription-logs/:id/:action/', {
                    id: '@id',
                    action: '@action',
                }, extendEndpoints({}, ['search']));
            }

            function teacher() {
                return $resource(url + '/api/admin/v1/users/:id/:action/:target/', {
                    id: '@id',
                    action: '@action',
                    target: '@target',
                }, extendEndpoints({}, ['comments', 'search']));
            }

            function userExport() {
                return $resource(url + '/api/admin/v1/user-export/:id/:action/:target/', {
                    action: '@action',
                    id: '@id',
                    target: '@target',
                }, extendEndpoints({}, ['search']));
            }

            function winbackCampaign() {
                return $resource(url + '/api/admin/v1/winback-campaigns/:id/:action/:target/', {
                    id: '@id',
                    action: '@action',
                    target: '@target',
                }, extendEndpoints({}, ['comments', 'recycle', 'search']));
            }

            function winbackOffer() {
                return $resource(url + '/api/admin/v1/winback-offers/:id/:action/:target/', {
                    id: '@id',
                    action: '@action',
                    target: '@target',
                }, extendEndpoints({}, ['comments', 'recycle', 'search', 'translations']));
            }

            function winbackStateOffer() {
                return $resource(url + '/api/admin/v1/winback-state-offers/:id/:action/:target/', {
                    id: '@id',
                    action: '@action',
                    target: '@target',
                }, extendEndpoints({}, ['comments', 'search']));
            }

            function school() {
                return $resource(url + '/api/admin/v1/schools/:id/:action/:target/', {
                    id: '@id',
                    action: '@action',
                    target: '@target',
                }, extendEndpoints({
                    usage: {
                        method: 'GET',
                        params: {
                            action: 'usage',
                        },
                        isArray: true,
                    },
                    mergeWith: {
                        method: 'PATCH',
                    }
                }, ['comments', 'recycle', 'search']));
            }

            function openSchool() {
                return $resource(url + '/api/open/v1/schools/:action/', {
                    action: '@action'
                });
            }

            function recycleBin() {
                return $resource(url + '/api/admin/v1/recycle-bin/:id/:action/', {
                    id: '@id',
                    action: '@action'
                }, {
                    search: {
                        method: 'GET',
                        params: {
                            action: 'search',
                        }
                    },
                    delete: {
                        method: 'DELETE',
                    },
                    restore: {
                        method: 'PATCH',
                        params: {
                            action: 'restore'
                        }
                    }
                });
            }

            function registration() {
                return $resource(url + '/api/open/v1/registrations/:action/', {
                    action: '@action'
                }, {
                    validateEmail: {
                        method: 'POST',
                        params: {
                            action: 'validate-email',
                        }
                    },
                });
            }

            function statistic() {
                return $resource(url + '/api/admin/v1/statistics/:action/', {
                    action: '@action'
                }, {
                    latestRegistrations: {
                        method: 'GET',
                        params: {
                            action: 'latest-registrations'
                        }
                    },
                    newSubscribersPerDay: {
                        method: 'GET',
                        params: {
                            action: 'new-subscribers-per-day'
                        }
                    },
                    trialsForMonth: {
                        method: 'GET',
                        params: {
                            action: 'trials-for-month'
                        }
                    },
                    conversionRatesForMonth: {
                        method: 'GET',
                        params: {
                            action: 'conversion-rates-for-month'
                        }
                    },
                    customerLifetimeValueForMonth: {
                        method: 'GET',
                        params: {
                            action: 'customer-lifetime-value-for-month'
                        }
                    },
                });
            }

            function user() {
                return $resource(url + '/api/admin/v1/users/:id/:action/:target/', {
                    action: '@action',
                    id: '@id',
                    target: '@target',
                }, extendEndpoints({
                    login: {
                        method: 'POST',
                        params: {
                            id: 'login',
                        }
                    },
                    removeFromGroup: {
                        method: 'PATCH',
                        params: {
                            action: 'remove-from-group',
                        }
                    },
                    addToGroup: {
                        method: 'PATCH',
                        params: {
                            action: 'add-to-group',
                        }
                    },
                    sendWelcome: {
                        method: 'PATCH',
                        params: {
                            action: 'send-welcome',
                        }
                    },
                    changePassword: {
                        method: 'PATCH',
                        params: {
                            action: 'update'
                        }
                    },
                    playedGames: {
                        method: 'GET',
                        params: {
                            action: 'played-games'
                        },
                        isArray: true,
                    }
                }, ['comments', 'recycle', 'search']));
            }

            /**
             * Extends the endpoints object with the selected base endpoints.
             *
             * @param {object} endpointsObject The endpoints object that should be extended.
             * @param {string[]} endpointsList The list of endpoints the object should be extended with.
             *
             * The available options are: comments, recycle, search, translations.
             *
             * @return {object} The original endpoints object extended with the selected endpoints.
             */
            function extendEndpoints(endpointsObject, endpointsList) {
                endpointsList.forEach(function (endpoint) {
                    switch (endpoint) {
                        case 'comments':
                            endpointsObject.getComments = {
                                method: 'GET',
                                params: {
                                    action: 'comments'
                                }
                            };
                            endpointsObject.postComment = {
                                method: 'POST',
                                params: {
                                    action: 'comments',
                                    overridePatch: true
                                }
                            };
                            endpointsObject.deleteComment = {
                                method: 'POST',
                                params: {
                                    method: 'DELETE',
                                    params: {
                                        action: 'comments'
                                    }
                                }
                            };
                            break;
                        case 'recycle':
                            endpointsObject.recycle = {
                                method: 'PATCH',
                                params: {
                                    action: 'recycle'
                                }
                            };
                            break;
                        case 'search':
                            endpointsObject.search = {
                                method: 'GET',
                                params: {
                                    id: 'search',
                                }
                            };
                            break;
                        case 'translations':
                            endpointsObject.getTranslationStructure = {
                                method: 'GET',
                                params: {
                                    action: 'translation-structure'
                                },
                                cache: true
                            };
                            break;
                    }
                });

                return endpointsObject;
            }
        }

    }

)();